var React = require('react');

function Resize (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"m73 44v-17h-17v4h10.17l-2.73 2.74-8.49 8.48-23.95 23.95v-10.17h-4v17h17v-4h-10.17l23.95-23.95 8.48-8.49 2.74-2.73v10.17z"})));
}

Resize.defaultProps = {"id":"Layer_1","enableBackground":"new 0 0 100 100","height":"40","viewBox":"0 0 100 100","width":"40","fill":"#fff"};

module.exports = Resize;

Resize.default = Resize;
